export default __webpack_public_path__ + "static/media/Strangler's Tunic of Creeping Death.9f281de6.jpg";